module.exports = __webpack_public_path__ + "205f07b3883c484f27f40d21a92950d4.ttf";